module.exports = __webpack_public_path__ + "static/media/Nirma_University_Logo-removebg-preview.2dddc49c.png";